import {
    CORE_CREATE_FBS_SUCCESS,
    CORE_CREATE_FBS_REQUEST,

    CORE_EDIT_FBS_SUCCESS,
    CORE_EDIT_FBS_REQUEST,

    CORE_LOAD_ALL_FBS_SUCCESS,
    CORE_LOAD_ALL_FBS_REQUEST,

    CORE_LOAD_FBS_SUCCESS,
    CORE_LOAD_FBS_REQUEST,

    CORE_DELETE_FBS_SUCCESS,
    CORE_DELETE_FBS_REQUEST,

    CORE_FILTER_FBS_REQUEST,
    CORE_FILTER_FBS_SUCCESS,
} from '../../types'

const initialState = []
export default {
    fbs: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_FBS_REQUEST:
            case CORE_LOAD_FBS_REQUEST:
            case CORE_EDIT_FBS_REQUEST:
            case CORE_DELETE_FBS_REQUEST:
                return initialState

            case CORE_CREATE_FBS_SUCCESS:
            case CORE_LOAD_FBS_SUCCESS:
            case CORE_EDIT_FBS_SUCCESS:
            case CORE_DELETE_FBS_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}

            default:
                return state
        }
    },
    fbsList:(state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_FBS_REQUEST:
            case CORE_FILTER_FBS_REQUEST :
            
            return initialState
            
            case CORE_LOAD_ALL_FBS_SUCCESS:
            case CORE_FILTER_FBS_SUCCESS :
                if (action.payload) {
                    return action.payload
                }
                else return [{}]

            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/fbs/reducer.js